import {Component, OnInit} from '@angular/core';
import {firstValueFrom} from "rxjs";
import {AuthenticationService} from "../../services/authentication.service";
import {Router, RouterLink} from "@angular/router";
import {ButtonComponent} from "../../components/ui/button/button.component";
import {TitleComponent} from "../../components/ui/title/title.component";
import {TranslateModule} from "@ngx-translate/core";
import {LoaderComponent} from "../../components/ui/loader/loader.component";

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [
    ButtonComponent,
    RouterLink,
    TitleComponent,
    TranslateModule,
    LoaderComponent
  ],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.scss'
})
export class RedirectComponent implements OnInit {
  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  async ngOnInit(): Promise<void> {
    const authenticated = await this.authenticationService.waitForRedirect();

    if (authenticated) {
      await this.router.navigateByUrl('/');
    } else {
      await this.router.navigateByUrl('/login');
    }
  }
}
